import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
	/** Reference date (today) shown as the PRO baseline. */
	referenceDate: string; // ISO date string
	/** CSV download handler. */
	onExportCsv?: () => void;
}

// PRO toolbar (prototype): 기준일(baseline) + CSV on one row. Treatment period is in the PatientHeader.
export function ProToolbar({ referenceDate, onExportCsv }: Props) {
	const { t } = useTranslation(["medical"]);
	const formatted = referenceDate
		? (() => {
				const d = new Date(referenceDate);
				return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")}`;
			})()
		: "";

	return (
		<div className="pro-toolbar">
			<span className="pro-toolbar__meta">
				{t("medical:patients.pro.referenceDate")} {formatted}
			</span>
			{/* No handler = no CSV (the EMR view-only screen, SHCT-994). */}
			{onExportCsv && (
				<button
					type="button"
					className="btn btn--secondary btn--sm"
					onClick={onExportCsv}
				>
					<Download size={14} style={{ marginRight: 4 }} />
					CSV
				</button>
			)}
		</div>
	);
}
